import { AppModules } from "@/types/Module.ts";
import { AppMenuitem } from "@/types/Menu.ts";

export class ModuleUtils {
  public static isModule(value: string | AppModules): boolean {
    return Object.keys(AppModules).some((x) => x === value);
  }

  public static findModuleByPath(items: Array<AppMenuitem>, path: string): AppModules | string | undefined {
    return items.find((x) => {
      return x.path !== "/" && this.isModule(x.id) && x.path.startsWith(path);
    })?.id;
  }

  public static getModuleName(module: AppModules): string {
    switch (module) {
      case AppModules.DASHBOARD:
        return "Dashboard";
      case AppModules.TICKETS:
        return "Tickets";
      case AppModules.CHANNELS:
        return "Canales";
      case AppModules.SUPPORTS:
        return "Material de apoyo";
      case AppModules.REPORTS:
        return "Reportes";
      case AppModules.INVOICING:
        return "Facturación";
      case AppModules.DYNAMIC_REPORT:
        return "Reporte dinámico";
      case AppModules.HELP:
        return "Ayuda";
      default: {
        return "--";
      }
    }
  }
}
